function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M135.255 127C144.112 127 152.451 118.612 155.175 112.391C157.9 106.171 158.466 99.2245 156.785 92.6481C155.104 86.0717 151.271 80.24 145.891 76.0733C140.511 71.9067 133.89 69.6425 127.074 69.638H119.343C117.486 62.486 114.024 55.8463 109.219 50.218C104.413 44.5896 98.3883 40.1192 91.5975 37.1427C84.8068 34.1662 77.4266 32.7612 70.0119 33.0331C62.5972 33.3051 55.3409 35.2471 48.7886 38.713C42.2362 42.179 36.5583 47.0787 32.1817 53.0439C27.8051 59.009 24.8437 65.8844 23.5201 73.153C22.1966 80.4217 22.5453 87.8945 24.5401 95.0096C26.5349 102.125 36.06 127 70.0119 127",
  fill: "#E8FAFC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5619 90.522C44.5291 88.6952 45.9972 87.1967 47.8243 87.1967C51.4013 87.1967 57.116 87.1967 61.1175 87.1967C64.7098 87.1967 66.5762 89.4882 67.5127 91.4289C68.2151 92.8845 69.582 94.0906 71.1982 94.0906H107.63C109.46 94.0906 110.933 95.5941 110.896 97.4239L109.99 141.8C109.954 143.578 108.503 145 106.724 145H48.7491C46.9678 145 45.515 143.573 45.483 141.792L44.5619 90.522Z",
  fill: "#16C5D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M124.523 92.2467C124.565 92.2779 124.596 92.3215 124.611 92.3711L124.954 93.4751C124.969 93.5247 124.968 93.5779 124.951 93.6269L124.575 94.7204C124.558 94.7693 124.526 94.8116 124.483 94.8414L123.531 95.5063C123.489 95.536 123.438 95.5516 123.386 95.5508L122.222 95.5329C122.17 95.5321 122.12 95.5149 122.078 95.4837L121.148 94.7904C121.106 94.7592 121.075 94.7156 121.059 94.6659L120.717 93.5619C120.702 93.5123 120.703 93.4592 120.72 93.4101L121.096 92.3167C121.113 92.2678 121.145 92.2254 121.188 92.1957L122.14 91.5308C122.182 91.501 122.233 91.4855 122.285 91.4863L123.449 91.5042C123.501 91.505 123.551 91.5222 123.593 91.5533L124.523 92.2467Z",
  fill: "#FFC300"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.96,
  cy: 88.9585,
  rx: 0.534802,
  ry: 0.531923,
  fill: "#1194A3"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 119.048,
  cy: 103.054,
  rx: 0.803289,
  ry: 0.797884,
  fill: "#1194A3"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 47.987,
  cy: 76.66,
  rx: 0.534802,
  ry: 0.531923,
  fill: "#1194A3"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 39.4192,
  cy: 81.9792,
  rx: 1.07105,
  ry: 1.06385,
  fill: "#FFC300"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 26.3585,
  height: 27.2145,
  rx: 2.45,
  transform: "matrix(-0.799052 0.602736 -0.601843 -0.797496 75.3348 51.504)",
  fill: "#16C5D9"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 23.1044,
  height: 20.0869,
  rx: 1.63333,
  transform: "matrix(-0.799052 0.602736 -0.601843 -0.797496 73.0598 51.1931)",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 43,
  y: 35,
  width: 30,
  height: 30
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.1044,
  height: 20.0869,
  rx: 1.63333,
  transform: "matrix(-0.799052 0.602736 -0.601843 -0.797496 73.0598 51.1931)",
  fill: "white"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.8744 48.5944C63.0415 49.9779 61.65 51.0276 60.3651 50.4872L47.7194 45.1692L61.2306 34.9775L62.8744 48.5944Z",
  fill: "#1194A3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.1115 51.5988C54.2715 52.9759 52.8893 54.0185 51.6087 53.4867L41.9888 49.4918L52.9097 41.254L54.1115 51.5988Z",
  fill: "#0B636D"
}));

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 1.95372,
  ry: 1.94264,
  transform: "matrix(-0.798544 0.602353 -0.602229 -0.798008 57.1223 55.2809)",
  fill: "#FFC400"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M57.2509 21.8349C56.9039 21.2721 55.9123 19.7375 52.3877 22.5432C49.6723 24.7048 48.6413 25.0999 45.4901 25.5748C48.6716 25.6983 53.8017 26.1193 55.6474 25.1319C57.4931 24.1446 57.5978 22.3977 57.2509 21.8349Z",
  fill: "#E0B2A3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9074 25.5888C40.0588 25.6201 33.8214 28.4343 31.4337 29.8375C29.9861 34.073 27.5587 42.8375 29.4301 44.012C31.7693 45.48 34.4541 40.2366 35.6886 43.3559C36.9232 46.4751 41.9813 46.252 45.2296 46.9782C48.478 47.7044 50.3526 46.2957 49.4017 44.4882C48.4509 42.6807 46.8468 43.1237 45.3533 42.3105C43.8597 41.4973 43.2753 39.9423 43.7971 37.6733C44.3189 35.4044 46.0644 35.383 47.8393 36.1021C48.5107 36.3741 48.7044 36.8372 48.7929 37.3702L51.9814 34.9706C51.1403 33.2923 49.6964 32.2719 49.4279 31.9757C49.08 31.592 48.8357 31.4236 49.5114 31.3851C50.187 31.3466 53.2939 31.6513 55.603 31.9103C57.9121 32.1692 58.7176 31.212 58.8475 30.2933C58.9773 29.3746 58.5073 28.9067 57.8873 28.5514C59.1636 28.5308 59.8941 27.6299 59.874 26.8239C59.8539 26.0179 59.7867 25.0714 58.0411 25.0927C56.2956 25.1141 53.2181 25.5498 45.9074 25.5888Z",
  fill: "#E4BDB1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.9666 25.668L34.2198 26.2605C34.6696 26.2841 35.0153 26.6672 34.9927 27.1168L34.1439 43.9607C34.1236 44.3637 33.8118 44.6914 33.4101 44.7319L22.5244 45.8311C22.2979 45.8811 22.0685 45.9 21.8374 45.8856C19.1314 45.7176 17.2191 41.0581 17.5662 35.4783C17.9078 29.9867 20.3107 25.6503 22.9663 25.6748L22.9666 25.668Z",
  fill: "#0B636D"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  width: 27.1639,
  height: 28.0395,
  rx: 2.45,
  transform: "matrix(-0.894342 -0.449372 -0.448663 0.892696 109.37 83.6433)",
  fill: "#1194A3"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  width: 23.8103,
  height: 20.6958,
  rx: 1.63333,
  transform: "matrix(-0.894342 -0.449372 -0.448663 0.892696 107.122 84.3795)",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 77,
  y: 74,
  width: 30,
  height: 29
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.8103,
  height: 20.6958,
  rx: 1.63333,
  transform: "matrix(-0.894342 -0.449372 -0.448663 0.892696 107.122 84.3795)",
  fill: "white"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M97.2788 88.8985C97.1917 87.4652 95.5866 86.6587 94.3843 87.4442L82.5516 95.175L98.136 103.006L97.2788 88.8985Z",
  fill: "#1194A3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.8394 87.4747C87.7464 86.0491 86.1521 85.2481 84.9525 86.0241L75.9416 91.8537L88.5384 98.1831L87.8394 87.4747Z",
  fill: "#0B636D"
}));

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 2.01349,
  ry: 2.00147,
  transform: "matrix(-0.893744 -0.449071 -0.448966 0.8933 90.2088 83.1851)",
  fill: "#FFC400"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M84.8913 63.4972C85.1212 62.856 85.7937 61.0977 89.9452 63.1761C93.1436 64.7773 94.2673 64.9561 97.5455 64.7642C94.3643 65.566 89.2821 67.0824 87.2108 66.4798C85.1395 65.8773 84.6615 64.1385 84.8913 63.4972Z",
  fill: "#E0B2A3"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M97.1279 64.8673C103.031 63.6538 109.919 65.1633 112.626 66.0698C114.988 70.0317 119.304 78.3512 117.667 79.9336C115.622 81.9115 111.798 77.1968 111.218 80.6044C110.638 84.0119 105.491 84.8637 102.371 86.2873C99.251 87.7109 97.0608 86.6897 97.6341 84.665C98.2074 82.6404 99.919 82.7454 101.251 81.6077C102.584 80.4699 102.841 78.7778 101.832 76.6014C100.822 74.4249 99.0576 74.775 97.4215 75.8777C96.8026 76.2949 96.706 76.803 96.7304 77.3592L93.0043 75.6187C93.4945 73.7477 94.7327 72.4116 94.9402 72.0558C95.2091 71.5949 95.4195 71.3731 94.7302 71.4781C94.0408 71.5831 90.9735 72.5516 88.7007 73.3043C86.4279 74.0569 85.4118 73.2633 85.085 72.3648C84.7582 71.4662 85.1323 70.8944 85.6816 70.4043C84.3905 70.6551 83.462 69.9024 83.3104 69.0855C83.1588 68.2686 83.0249 67.3 84.7892 66.95C86.5536 66.5999 89.7491 66.3841 97.1279 64.8673Z",
  fill: "#E4BDB1"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.273 60.0636L109.03 63.0627C108.595 63.1788 108.336 63.625 108.451 64.0602L112.91 80.9056C113.013 81.2957 113.386 81.552 113.787 81.5087L125.017 80.2975C125.257 80.2997 125.492 80.2699 125.722 80.2062C128.415 79.4609 129.349 74.3564 127.809 68.8049C126.294 63.3415 122.947 59.4813 120.275 60.0706L120.273 60.0636Z",
  fill: "#8BE3ED"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2823 102.988C42.1516 101.099 43.6482 99.4954 45.5412 99.4954H109.925C111.818 99.4954 113.314 101.099 113.184 102.988L110.486 141.959C110.368 143.671 108.944 145 107.227 145H48.2383C46.5217 145 45.098 143.671 44.9794 141.959L42.2823 102.988Z",
  fill: "#8BE3ED"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M66.9563 128.442C66.7986 127.45 67.5651 126.552 68.5694 126.552H86.8964C87.9007 126.552 88.6671 127.45 88.5094 128.442L88.0513 131.324C87.9252 132.118 87.2413 132.701 86.4382 132.701H69.0276C68.2245 132.701 67.5405 132.118 67.4145 131.324L66.9563 128.442Z",
  fill: "white"
});

function SvgPictures(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 145,
    viewBox: "0 0 158 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictures);
export default __webpack_public_path__ + "static/media/pictures.f4d37b1a.svg";
export { ForwardRef as ReactComponent };